var panoramaViewStatic = {
	front: "",
	back: "2"
};

function panoramaView(id,props, half, turn) {
	this.ident = id;
	this.properties = props;
	this.paused = false;
	//this.loaded = {a:0, b:0, c:0, d:0, e:0, f:0};
	//this.wfix = false;
	//this.wfixname = "";
	this.autorunH = 1;
	this.zoomAcc = 0;
	this.zooming = 0;
	this.loadSpots = props.loadSpots != undefined ? props.loadSpots : true;
	this.showLoading = props.showLoading != undefined ? props.showLoading : true;

	if (turn != undefined && turn != "") {
		var t = turn.split(",");

		if (t.length > 1) this.turn_to = [parseFloat(t[0]) + 90 - 4, -1 * parseFloat(t[1])];
		else this.turn_to = [parseFloat(t[0]) + 90 - 4];
	}

	if (player.turn_timer != undefined && player.turn_timer != null) {
		clearTimeout(player.turn_timer);
		player.turn_timer = null;
	}

	if (this.loadSpots) HotSpotManager.setVisibility(false);

	if (!window.WebGLRenderingContext)
		this.renderer = new cubeCssRenderer(id, props, half);
	else
		this.renderer = new sphereWebGLRenderer(id, props, half);

	if (this.showLoading != undefined) this.renderer.showLoading = this.showLoading;

	panoramaViewStatic.renderer = this.renderer;
	panoramaViewStatic.root = this;

	if (player.cms && panoramaViewStatic.reticle == undefined) {
		panoramaViewStatic.reticle = $("<div class='reticle'></div>");
		$("#ui").append(panoramaViewStatic.reticle);
	}

	this.ctween = new CameraTween();
	
	var drs = player.dir.toString().split(",");

	//console.log(drs);

	if ($("#pano") == undefined || $("#pano").length == 0) {
		this.renderer.loadTemplate();
	} else {
		this.renderer.reUse();
	}
			
	this.renderer.build();

	if (isNaN(parseFloat(this.properties.properties.north)) || this.properties.properties.north == "0") {
		//this.properties.properties.north = 0;
		this.properties.properties.north = WCompass.calculateNorth();
	}
	
	if (drs[0].substr(0, 1) == "@") {
		var heading = parseFloat(drs[0].substr(1));
		drs[0] = heading + parseFloat(this.properties.properties.north);
		player.lastHeading = heading;
	} else {
		player.lastHeading = drs[0] - parseFloat(this.properties.properties.north);
	}

	if (drs.length >= 1 && drs[0] != "") {
		this.renderer.rx = parseFloat(drs[0]) + 90 - 4;
	}
	if (drs.length >= 2) this.renderer.ry = parseFloat(drs[1]) * -1;
	
	
	panoramaViewStatic.ident = id;

	if (panoramaViewStatic.swipe == undefined)	{
		panoramaViewStatic.swipe = new swiper();
	}
	swipe = panoramaViewStatic.swipe; //new swiper();
	
	$("#info").show();

	this.setNav();
}

panoramaView.prototype = {
	rx: 0,
	ry: 0,
	inX: 0,
	inY: 0,
	panning:false,
	swipe:{},
	veryHighQualityLoaded:false,
	basePerspective: 550, //tak jak perspective w css
	zoom:550, // 500 zoom powinno byc rowne perspective w css
	minZoom:450, // 550
//	minZoom:250, // 550
	maxZoom:1550, // 750
	zoomModifier:0, // modyfikacja perspektywy dla roznych ukladow ekranow - dla portrait chcemy duzo mniejszy zoom bazowy
	hqZoom:600, // 600
	zoomMultiplier:1,
	swipeSpeed:1,
	keys:{},
	
  	realZoom: function() {
  		return this.zoom + this.zoomModifier;
  	},

  	setNav: function() {  		
  		this.nav = $("<div class='nav'></div>");

		//SpeechManager.prepareTip("PLAYER.ZOOM_IN", "TIPS");
		//SpeechManager.prepareTip("PLAYER.ZOOM_OUT", "TIPS");

  			var zin = $("<a href='javascript:void(null)' class='speaks' data-speak='PLAYER.ZOOM_IN' data-speakgroup='TIPS' title='" + TPL.lng("tips.clicktozoomin", 'Kliknij aby przybliżyć') + "'><i class='fa fa-search-plus'></i></a>");
  			var zout = $("<a href='javascript:void(null)' class='speaks' data-speak='PLAYER.ZOOM_OUT' data-speakgroup='TIPS' title='" +  TPL.lng("tips.clicktozoomout", 'Kliknij aby oddalić') + "'><i class='fa fa-search-minus'></i></a>");

  			this.nav.append(zin);
  			this.nav.append(zout);

  			var self = this;
  			zin.on(Events.pointer.down, function() {
  				self.zooming = 0.5;
  			});
  			zin.on(Events.pointer.up, function(evt) {
  				self.zooming = 0;
  				evt.preventDefault();
  			});
  			zout.on(Events.pointer.down, function() {
  				self.zooming = -0.5;
  			});
  			zout.on(Events.pointer.up, function(evt) {
  				self.zooming = 0;
  				evt.preventDefault();
  			});

  		if (PROJECT.settings['ui/icons/zoom'] == "1") {
  			// nie potrzebne, wlaczone dla wszystkich
  		}

  		$("#ui").append(this.nav);

//		SpeechManager.enableSpeech(".nav", ".speaks", 0, "TOPMENU");
		SpeechManager.enableSpeech(".nav", ".speaks", 0, "TIPS");
  	},

  	clearNav: function() {
  		if (this.nav != undefined) this.nav.remove();
  	},

  	setPerspective: function(v) {
  		//this.minZoom = v;
  		this.zoom = v;

  		if (this.zoom < this.minZoom) this.zoom = this.minZoom;
		if (this.zoom > this.maxZoom) this.zoom = this.maxZoom;

  		this.renderer.setPerspective(this.realZoom());
  	},

	load: function() {
		this.spots = this.properties.properties.spots;
		panoramaViewStatic.spots = this.spots;
		
		this.renderer.load();

		this.autorunH = parseFloat(this.properties.properties.autorunH);
		if (isNaN(this.autorunH)) this.autorunH = 0;

		if (player.cms) {
			this.autorunH = 0;
		} else {
			this.autorunH = 0.1;
		}

		if (this.properties.folder.nozoom != undefined) {
			var zmult = 100 - parseInt(this.properties.folder.nozoom);
			var zval = (this.maxZoom - this.zoom) * zmult / 100;
			this.maxZoom = this.zoom + zval;
		}

		//console.log(this.properties.properties.north);
		if (this.loadSpots) {
			HotSpotManager.setVisibility(false);
			
			HotSpotManager.addAll(this.spots, this.properties.properties.north);
			
			HotSpotManager.clearRenderables();
			HotSpotManager.addRenderables(this.properties.collectibles, 'collectible');
			
			for(var ind in this.properties.indicators) {
				var idc = this.properties.indicators[ind];

				var dy; // = parseFloat(idc.look_y) * -30;

				dy = -1 * Math.tan(idc.look_y * (Math.PI/180)) * 1500;

				var spot = new panoramaHotSpot({'ident': idc.place_id, 'spot': "1", 'x':parseFloat(idc.look_x) + 1, 'y':dy, "place": {"type": "indicator", "place_name": idc.title}}, ind, 0);
				//var spot = new panoramaHotSpot({'ident': idc.place_id, 'spot': "1", 'x':parseFloat(idc.look_x) + 1, 'y':parseFloat(idc.look_y) * -1, "place": {"type": "indicator", "place_name": idc.title}}, ind, 0);

				spot.indicator = idc;
				
				/*
				spot.addHelper(
					$("<a href='javascript:void(null);' on" + Events.pointer.up + "='player.currentView.fastTurnTo(" + spot.lookAtCoords().x + "," + spot.lookAtCoords().y + ")' class='indicator_left ind_title'>" + idc.title + " " + idc.no + "<br><small class='ind_title2'>" + idc.title2 + "</small><div class='arrow'></div></a>"), 
					$("<a href='javascript:void(null);' on" + Events.pointer.up + "='player.currentView.fastTurnTo(" + spot.lookAtCoords().x + "," + spot.lookAtCoords().y + ")' class='indicator_right ind_title'>" + idc.title + " " + idc.no + "<br><small class='ind_title2'>" + idc.title2 +  "</small><div class='arrow'></div></a>"));
				spot.helperWidth = 120;
				*/

				spot.tag = 'indicator';
				spot.canProceed = false;
				spot.proceedEvent = function(f) {
					if (f) this.node.find(".indtoggle").click();
				}.bind(spot);

				spot.idc = idc;

				spot.speakHoverEvent = function() {
					var glyph = this.idc.no;
					if (glyph == undefined || glyph == "") glyph = this.idc.title;
					//console.log("speak hover: " + this.idc.no);

//					if (HotSpotManager.lastspeak != glyph && this.visible) {
					if (HotSpotManager.lastidc != this.idc.id && this.visible) {
						SpeechManager.speakTip(glyph, "TOPMENU");
						HotSpotManager.lastidc = this.idc.id;
						//HotSpotManager.lastspeak = glyph;
						HotSpotManager.lastspeak = "";
					}

					HotSpotManager.lastspeaktitle = glyph;
				}.bind(spot);


//					spot.node.html("<div class='indicator_plate indtoggle'><div class='plate'><b class='ind_title'>" + idc.title + " " + idc.no + "</b><Br><span class='ind_title2'>" + idc.title2 + "</span></div><a href='javascript:void(null);' class='more'><i class='fa fa-angle-down'></i></a><div class='panel'>" + (idc.info != "" ? idc.info.replace(new RegExp('\n', 'g'), '<br>') : "") + "</div></div>");
					var glyph = idc.no;
					if (glyph == undefined || glyph == "") glyph = idc.title;
					spot.node.html("<div class='indicator_plate ind_style_" + idc.style + " indtoggle'><div class='plate' style='min-width:60px; width:auto;transform:translateX(-50%);font-size:20px;margin-left:0px'>" + glyph + "</div><div class='help-1'><img src='assets/ind.svg'></div><a href='javascript:void(null);' class='more' style='left:-12px;'><i class='fa fa-angle-down'></i></a><div class='panel' style='font-size:14px;line-height:1.5;width: 420px;left:-220px;top:45px;border-radius:5px;'><div  onclick='event.stopPropagation();' class='readable'><b class='ind_title'>" + idc.title + " " + idc.no + "</b><Br><span class='ind_title2'>" + (idc.title2 != "" ? idc.title2.replace(new RegExp('\n', 'g'), '<br>') : "") + "</span><hr size='1'>" + (idc.info != "" ? idc.info.replace(new RegExp('\n', 'g'), '<br>') : "") + "</div><div style='text-align:center'><a href='javascript:void(null)' class='close-pane'>Zamknij</a></div></div></div>");
					if (player.cms) {
						spot.node.append("<div class='indicator_selected'></div>");
						spot.editor.addUI();
						if (idc.hide == '1' || idc.hide == '2') spot.node.css("opacity", "0.5");
					} else if (idc.hide == '1' || idc.hide == '2') {
						spot.node.css("display", "none");
					}
					
					spot.node.find(".indtoggle").on("click", function() {
						var m = $(this).find(".more");
						m.toggleClass("more_flipped");
						if (m.parent().find(".panel").html() != "") m.parent().find(".panel").toggleClass("panel_open");

						if (m.parent().find(".panel").hasClass("panel_open")) AudioManager.play("assets/audio/openIndicator.mp3", Volume.currentTipVolume());
						else AudioManager.play("assets/audio/closeIndicator.mp3", Volume.currentTipVolume());
					});
					
				if (idc.info.trim() == "") {
					spot.node.find(".indtoggle .more").hide();
					//spot.node.html("<div class='indicator_plate'><div class='plate'><b class='ind_title'>" + idc.title + " " + idc.no + "</b><Br><span class='ind_title2'>" + idc.title2 + "</span></div></div>");
				}
				//spot.node.css("left", "-60px");
				HotSpotManager.add(spot);
			}
		}

		this.setPerspective(650);

		if (this.properties.params != false && this.properties.params.zoom != undefined) {
			var pz = parseFloat(this.properties.params.zoom);
			this.zoom = 650 * (pz / 1.4);
			this.setPerspective(this.zoom);
		}

		this.reorient();

	},

	loaded: function() {
		if (this.turn_to != undefined) {
			player.turn_timer = setTimeout(function() {
				player.turn_timer = null;
				if (player.currentView.turn_to.length > 1)
					player.currentView.turnTo(player.currentView.turn_to[0], player.currentView.turn_to[1]);
				else
					player.currentView.turnTo(player.currentView.turn_to[0], player.currentView.renderer.ry);

			}, 1000);
//			}, 2500);
		}

	},
	
	reorient: function() {
		//console.log('reorient');
		if ($(window).width() < $(window).height()) {
			this.zoomModifier = -250;
			this.swipeSpeed = 2;
		} else {
			this.zoomModifier = 0;
			this.swipeSpeed = 1;
		}

		this.renderer.reorient();
		this.setPerspective(this.zoom);
	},
		
	process: function() {
		this.renderer.process();

		if (player.currentView != this) return;

		this.zoom += swipe.distance() * this.zoomMultiplier;

		if (this.zooming != 0) this.mouseWheel(this.zooming);

		if (this.zoomAcc != 0) {
			this.zoom *= (1 + (this.zoomAcc / 600));
			this.zoomAcc *= 0.9;
		}
		
		if (this.zoom < this.minZoom) this.zoom = this.minZoom;
		if (this.zoom > this.maxZoom) this.zoom = this.maxZoom;
		
		if (this.zoom > this.hqZoom && this.veryHighQualityLoaded == false) {
			//this.loadQuality(1280);
			this.veryHighQualityLoaded = true;
		}

		if (this.zoomAcc != 0) {
			this.setPerspective(this.zoom);
		}

		var sx = swipe.inertiaX() * this.swipeSpeed;
		var sy = swipe.inertiaY() * this.swipeSpeed;

		if (Math.abs(sx) > 0.02 || Math.abs(sy) > 0.02 && HotSpotManager.closest != undefined) {
			HotSpotManager.closest.show();
		}
		
		//if (!isNaN(sx) && !isNaN(sy)) {
		this.renderer.rx += sx;// + 0.02; // 0.02
		this.renderer.ry += sy;
		//}


		this.kb_lastzooming = this.kb_zooming;		
		this.kb_zooming = 0;

		if (player.keys['='] || player.keys['+']) {
			this.zooming = 0.5;
			this.kb_zooming = 1;
		}

		if (player.keys['-']) {
			this.zooming = -0.5;
			this.kb_zooming = 1;
		}

		if (this.kb_lastzooming == 1 && this.kb_zooming == 0) this.zooming = 0;


		if (player.keys['ArrowLeft']) {
			this.renderer.rx -= 0.5 * (player.keyCtrl ? 0.05 : 1);
			if (HotSpotManager.closest != undefined) HotSpotManager.closest.show();
			HotSpotManager.closest.speak();
		}
		if (player.keys['ArrowRight']) {
			this.renderer.rx += 0.5 * (player.keyCtrl ? 0.05 : 1);
			if (HotSpotManager.closest != undefined) HotSpotManager.closest.show();
			HotSpotManager.closest.speak();
		}
		if (player.keys['ArrowUp']) {
			this.renderer.ry += 0.5 * (player.keyCtrl ? 0.02 : 1);
			if (HotSpotManager.closest != undefined) HotSpotManager.closest.show();
			HotSpotManager.closest.speak();
		}
		if (player.keys['ArrowDown']) {
			this.renderer.ry -= 0.5 * (player.keyCtrl ? 0.02 : 1);
			if (HotSpotManager.closest != undefined) HotSpotManager.closest.show();
			HotSpotManager.closest.speak();
		}

		/*
		if (player.keys['Enter'] && HotSpotManager.closest.visible) {
//		if (player.keys['Q'] && HotSpotManager.closest.visible) {
			HotSpotManager.closest.proceed();
		}
		*/

		//console.log(player.keys);

		this.ctween.process();

		if (this.ctween.isRunning()) {
			if (this.ctween.current.x != undefined) this.renderer.rx = this.ctween.current.x;
			if (this.ctween.current.y != undefined) this.renderer.ry = this.ctween.current.y;
			if (this.ctween.current.zoom != undefined) {
				this.renderer.setPerspective(this.ctween.current.zoom);
			}
		} else if (this.autorunH != 0 && Math.abs(sx) < 0.01 || Math.abs(sy) < 0.01) {
			if (player.idle) {
				this.renderer.rx += this.autorunH * 0.3;
			}
		}
		
		//console.log(this.properties.params);

		if (this.properties.properties == false) {
			if (this.properties.pano_type != 2) this.renderer.ry = 0;
		} else if (this.properties.properties.bend_type == "b") {
			//console.log('reorient');
			// Pawel kazal calkowicie wylaczyc blokade 19.11.2020
			/*
			if (this.renderer.ry < -this.properties.properties.benddown) this.renderer.ry = -(this.properties.properties.benddown * 1);
			if (this.renderer.ry > this.properties.properties.bendup) this.renderer.ry = (this.properties.properties.bendup * 1);
			*/
		} else if (this.properties.properties.bend_type == undefined) {
			//this.ry = -
		}
		
		//if (this.ry > 75) this.ry = 75;
		//if (this.ry < -75) this.ry = -75;
		
		if (this.renderer.ry > 89) this.renderer.ry = 89;
		if (this.renderer.ry < -89) this.renderer.ry = -89;
		
		this.inX *= 0.7;
		this.inY *= 0.7;
		
		if (this.panning) {
			this.calculateInertia(player._mouseX, player._mouseY);
		}

		if (player.cms) {
			$("#cmscoords").val((Math.round((this.renderer.rx - 86) * 100) / 100) + ", " + (Math.round(this.renderer.ry * 100) / -100));
		}
		
		HotSpotManager.process3D(this.getRX(), this.getRY(), this.realZoom());
	},	
	
	calculateInertia: function(px,py) {
		this.inX = (px - player._width * 0.5) * 0.01;
		if (this.inX > 5) this.inX = 5;
		if (this.inX < -5) this.inX = -5;
		
		this.inY = (player._height * 0.5 - py) * 0.01;
		if (this.inY > 5) player.inY = 5;
		if (this.inY < -5) player.inY = -5;
	},
	
	mouseDown: function(event) {
		this.panning = true;
		this.ctween.stop();

		swipe.start(event);

		//player.calculateInertia(player._mouseX, player._mouseY);
	},
	
	mouseUp: function(event) {
		swipe.end();
		this.panning = false;
	},
	
	mouseMove: function(event) {
		swipe.move(event);
	},

	mouseWheel: function(dt) {		
		this.zoomAcc += dt * 0.1;
		if (dt > 0 && this.zoomAcc < 10) this.zoomAcc = 10;
		if (dt < 0 && this.zoomAcc > -10) this.zoomAcc = -10;
	},
	
	clear: function() {
		//swipe = null;
		if (this.loadSpots) HotSpotManager.clear();
		this.renderer.clear();
		this.clearNav();
	},

	fastTurnTo: function(rx, ry) {
		this.ctween.reset();
		this.ctween.setSpeed(15);
		this.ctween.startAt(this.renderer.rx, this.renderer.ry);
		this.ctween.finishAt(rx, ry);
	},

	turnTo: function(rx, ry) {
		this.ctween.reset();
		this.ctween.startAt(this.renderer.rx, this.renderer.ry);
		this.ctween.finishAt(rx, ry);
	},

	turnToAnd: function(rx, ry, opts, fin) {
		var speed = 0;
		var rangeX = null;
		var rangeY = null;
		var distX = -1;
		var distY = -1;
		var instant = false;
		var angle = 0;

		this.ctween.reset();

		if (typeof opts === 'object') {
			rangeX = opts.rangeX;
			rangeY = opts.rangeY;
			speed = opts.speed;
		} else {
			speed = opts;
		}
		
		if(this.renderer.rx - rx <= 180) {
			angle = this.renderer.rx - rx;
		} else {
			angle = (rx+360) - this.renderer.rx;
		}

		if (rangeX != null) distX = Math.abs(angle);
		if (rangeY != null) distY = Math.abs(this.renderer.ry - ry);

		if (distX > 0 && distX < rangeX && distY > 0 && distY < rangeY) {
			instant = 1;
		};

		if (instant) {
			fin();
		} else {
			this.ctween.onFinish = fin;
			this.ctween.setSpeed(speed);
			this.ctween.startAt(this.renderer.rx, this.renderer.ry);
			this.ctween.finishAt(rx, ry);
		}
	},

	zoomToAnd: function(zoom, speed, fin) {
		this.ctween.reset();
		this.ctween.onFinish = fin;
		this.ctween.setSpeed(speed);
		this.ctween.zooming(this.renderer.zoom, this.renderer.zoom + zoom);
	},

	turnToSpot: function(s) {
		this.turnTo(s.properties.x, s.properties.y);
	},

	stopTurning: function() {
		try {
			this.ctween.stop();
		} catch(e) {

		}
	},

	pause: function() {
		this.paused = true;
	},

	resume: function() {
		this.paused = false;
	},

	old2angle: function(n) {
		return parseFloat(n) + 85;
//		return parseFloat(n) + (parseFloat(this.properties.properties.north) - 95) + 180;
	},
	beforeLeave: function() {
		if (this.renderer.beforeLeave != undefined) {
			this.renderer.beforeLeave();
		}
	},

	leaving: function() {
		if (this.renderer.leaving != undefined) {
			this.renderer.leaving();
		}
	},

	getRX: function() {
		return this.renderer.rx + this.renderer.disort.x;
	},

	getRY: function() {
		return this.renderer.ry + this.renderer.disort.y;
	},

	getHeadingText: function(result) {
		var rx = parseInt(this.getRX() - 90 + 4);
		rx = rx % 360;
		if (rx < 0) rx = 360 + rx;
		if (result == undefined) return rx + "," + parseInt(this.getRY() * -1);
		if (result == "x") return rx;
		if (result == "y") return parseInt(this.getRY() * -1);
	}
}